<template>
  <div class="lug-item" :style="{ marginBottom }">
    <button v-if="deleted" @click="onClickDelete" type="button" class="lug-item__delete">
      <img src="@/assets/img/clear-small-gray-icon.svg" alt="">
    </button>
    <div class="lug-item__top">
      <div class="lug-item__count">{{ orderNumber }}.</div>
      <div class="lug-item__icon">
        <img v-if="ageType === 'adult'" src="@/assets/img/adult-icon.svg" alt="">
        <img v-if="ageType === 'child'" src="@/assets/img/child-icon.svg" alt="">
      </div>
      <div class="lug-item__text">{{ weight }} KG</div>
      <app-input
        v-if="count"
        @input="onCountInput"
        v-model.number="local_count"
        type="number"
        min="1"
        class="input--45 input--center"
        :readonly="!deleted"
      />
    </div>
    <div v-if="clientSelected && seatsAssignment" class="lug-item__client">
      <img v-if="clientSelected.age_type" :src="require(`@/assets/img/${clientSelected.age_type}-icon.svg`)" alt="">
      <img v-else src="@/assets/img/age-null-icon.svg" alt="">
      <span>{{ clientSelected.full_name || '-' }}</span>
    </div>
    <div v-if="!seatsAssignment" class="lug-item__bot">
      <app-select
        @input="onChangeSelect"
        v-model="client"
        :options="clientsOptions"
        placeholder="Selected clients"
        label="full_name"
        class="select--250"
      >
        <template #custom-option="option">
          <img v-if="option.age_type" :src="require(`@/assets/img/${option.age_type}-icon.svg`)" alt="" class="select__img">
          <img v-else src="@/assets/img/age-null-icon.svg" alt="">
          {{ option.full_name }}
        </template>
      </app-select>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AppLugItem',
  props: {
    orderNumber: {
      type: Number,
      default: 1
    },
    ageType: {
      type: String,
      default: ''
    },
    weight: {
      type: Number,
      default: 0
    },
    clientSelected: {
      type: Object,
      default: null
    },
    clientsOptions: {
      type: Array,
      default: () => []
    },
    seatsAssignment: {
      type: Boolean,
      default: false
    },
    deleted: {
      type: Boolean,
      default: true,
    },
    count: {
      type: Number,
      default: null
    },
    marginBottom: {
      type: String,
      default: '10px'
    }
  },
  data() {
    return {
      client: null,
      local_count: this.count,
    }
  },
  watch: {
    clientSelected: {
      handler(val) {
        this.client = val
      },
      immediate: true,
    },
    count(val) {
      this.local_count = val
    }
  },
  methods: {
    onCountInput() {
      if (typeof this.local_count === 'number') this.$emit('onCountInput', this.local_count)
    },
    onChangeSelect() {
      this.$emit('onChangeLugClients', this.client)
    },
    onClickDelete() {
      this.$emit('onDeleteLugItem')
    }
  }
}
</script>

<style scoped lang="sass">
.lug-item
  position: relative
  display: flex
  justify-content: flex-start
  align-items: center
  gap: 10px
  padding: 10px
  border: 1px solid #dcdcdc
  border-radius: 10px
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08)
  background-color: #fff

.lug-item__top
  display: flex
  align-items: center
  gap: 10px

.lug-item__count
  display: flex
  align-items: center
  justify-content: center
  width: 36px
  height: 35px
  border-radius: 8px
  background-color: #eee
  color: #181818
  font-size: 12px
  font-weight: 600

.lug-item__icon
  display: inline-flex
  align-items: flex-end
  justify-content: center
  gap: 2px
  min-width: 38px
  height: 38px
  padding: 8px
  border: 1px solid rgba(0, 0, 0, 0.1)
  border-radius: 4px
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1)
  background: linear-gradient(180deg, #fff 0%, #f4f4f4 100%)
  transition: border 0.3s, background-color 0.3s

.lug-item__text
  font-weight: 500

.lug-item__price
  position: absolute
  right: 10px
  top: 50%
  transform: translateY(-50%)
  font-weight: 500

.lug-item__client
  display: flex
  align-items: center
  gap: 10px

  span
    color: #5f5f5f
    font-size: 13px
    transform: translateY(1px)

.lug-item__delete
  position: absolute
  top: 0
  right: 0
  padding: 10px
  line-height: 0
  z-index: 9
</style>
